import * as React from 'react';
import { Notification } from '@cian/push-manager';
import { IHttpApi } from '@cian/http-api/shared';

interface IProps {
  applicationServerKey: string;
  baseUrl: string;
  currentPage: number;
  currentSubdomain: string;
  expiresInSevenDays: number;
  httpApi: IHttpApi;
  isPushEnabled: boolean;
  notificationPermission: string;
  userId: string;
}

export class PushNotification extends React.Component<IProps, {}> {
  public render() {
    const {
      applicationServerKey,
      baseUrl,
      currentPage,
      currentSubdomain,
      expiresInSevenDays,
      httpApi,
      isPushEnabled,
      notificationPermission,
      userId,
    } = this.props;

    return currentPage === 1 && isPushEnabled && notificationPermission !== 'blocked' ? (
      <Notification
        hasSubdomain={currentSubdomain !== 'www'}
        checkFirstVisit
        userId={userId}
        applicationServerKey={applicationServerKey}
        httpApi={httpApi}
        baseUrl={baseUrl}
        expires={expiresInSevenDays}
        trackingLabel="From_cat_save"
      />
    ) : null;
  }
}
